import React from 'react'
import { Box, Stack, Text } from '@chakra-ui/react'
import moment from 'moment'
import {
  WhenToSendType,
  TransferRecurrenceType,
  TransferFrequencyType,
  TransferFrequencyText,
  WhenToSendText
} from '../TransferFrequency/Types'

export interface TSProps {
  transferRecurrence: TransferRecurrenceType
  whenToSend: WhenToSendType
  transferFrequency?: TransferFrequencyType
  numberOfTransfers?: number
  transferScheduledDate: string | Date
  transferStartDate: string | Date
}

const getRecurrenceText = (
  transferRecurrence: TransferRecurrenceType,
  transferFrequency: TransferFrequencyType
): string => {
  if (transferRecurrence === 'ONE_TIME') {
    return 'One Time'
  }
  return TransferFrequencyText[transferFrequency]
}

const ModalTransferScheduledPreview = ({
  transferRecurrence,
  whenToSend,
  transferFrequency,
  numberOfTransfers,
  transferScheduledDate,
  transferStartDate
}: TSProps) => {
  const dateFormatted = moment(transferScheduledDate).format('L')
  const startDateFormatted = moment(transferStartDate).format('L')
  return (
    <Stack spacing={4}>
      <Stack direction='row'>
        <Box data-testid='modalTransferFrequency' w='50%'>
          <Text fontWeight='bold'>Transfer Frequency</Text>
          <Text>{transferRecurrence && getRecurrenceText(transferRecurrence, transferFrequency!)}</Text>
        </Box>
        <Box data-testid='modalTransferDate' w='50%'>
          {transferRecurrence === 'ONE_TIME' && (
            <Text fontWeight='bold'>{whenToSend === 'IMMEDIATELY' ? 'When To Send' : 'Scheduled Date'}</Text>
          )}
          {transferRecurrence === 'RECURRING' && <Text fontWeight='bold'>Start Date</Text>}
          {transferRecurrence === 'ONE_TIME' && (
            <Text>{whenToSend === 'IMMEDIATELY' ? WhenToSendText[whenToSend] : dateFormatted}</Text>
          )}
          {transferRecurrence === 'RECURRING' && <Text>{startDateFormatted}</Text>}
        </Box>
      </Stack>
      {transferRecurrence === 'RECURRING' && (
        <Stack direction='row'>
          <Box data-testid='modalNumberOfTransfers' w='50%'>
            <Text fontWeight='bold'>Number of Transfers</Text>
            {Number(numberOfTransfers) > 0 ? <Text>{numberOfTransfers}</Text> : <Text>Until Canceled</Text>}
          </Box>
        </Stack>
      )}
    </Stack>
  )
}

export default ModalTransferScheduledPreview
